import { render } from "./ConnectionsPage.vue?vue&type=template&id=4767def8&ts=true"
import script from "./ConnectionsPage.vue?vue&type=script&lang=ts"
export * from "./ConnectionsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__